import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

import "../Styles/Card.css";
import "../Styles/CheckInCard.css";
import { timeAgo } from "../utils/format";
import { profilePath, venuePath } from "../utils/routes";
import DefaultAvatar from "./DefaultAvatar";
import LiveIcon from "./icons/LiveIcon";
import type { CheckInFeed } from "../data/types";

type Props = {
  feedObj: CheckInFeed;
};

export default function CheckInCard({ feedObj }: Props) {
  const name = feedObj.isSelf ? "You" : feedObj.userDisplayName;

  // "You is at" — verbet måste böjas efter vem raden handlar om.
  const verb = feedObj.stillThere
    ? feedObj.isSelf
      ? "are at"
      : "is at"
    : "checked in at";

  return (
    <div className="card-wrapper card-checkin">
      <div className="card-top">
        <Link to={profilePath(feedObj.userId)} className="checkin-avatar-link">
          <DefaultAvatar
            name={feedObj.userDisplayName}
            avatarUrl={feedObj.userAvatarUrl}
          />
        </Link>

        <div className="group-column">
          <p className="text-b">
            <Link to={profilePath(feedObj.userId)} className="checkin-name">
              {name}
            </Link>{" "}
            <span className="checkin-action">{verb}</span>{" "}
            <Link to={venuePath(feedObj.venueId)} className="checkin-venue">
              {feedObj.venueName}
            </Link>
          </p>

          <p className="text-damper">{timeAgo(feedObj.time)}</p>
        </div>

        {feedObj.stillThere && (
          <div className="checkin-live">
            <LiveIcon />
          </div>
        )}
      </div>

      <div className="checkin-body">
        <div className="checkin-place">
          <MapPin size={14} strokeWidth={2.2} />
          <Link to={venuePath(feedObj.venueId)} className="checkin-place-link">
            {feedObj.address || feedObj.venueName}
          </Link>
        </div>

        {feedObj.note && <p className="checkin-note">{feedObj.note}</p>}
      </div>
    </div>
  );
}
